/** Normalize ids for loading-state Set keys so UI + websocket events always match. */
export function normalizeIdPart(id: unknown): string {
    return String(id ?? '')
        .trim()
        .toLowerCase()
        .replace(/[{}]/g, '');
}

/** Match backend LessonFigureSpecParser.NormalizeFigureKey for event comparisons. */
export function normalizeFigureKey(key: string): string {
    const trimmed = String(key ?? '').trim();
    const match = trimmed.match(/Fig\.?\s*([A-Z])/i);
    return match ? `Fig. ${match[1].toUpperCase()}` : trimmed;
}

export function lessonLoadingStateKey(unitId: string, lessonId: string): string {
    return `${normalizeIdPart(unitId)}-${normalizeIdPart(lessonId)}`;
}

export function activityLoadingStateKey(unitId: string, lessonId: string, activityId: string): string {
    return `${normalizeIdPart(unitId)}-${normalizeIdPart(lessonId)}-${normalizeIdPart(activityId)}`;
}
